import { evidenceTypes } from "@/mocks/evidence";

type EvidenceEntriesProps = {
  activeType: string;
  onSelectType: (typeId: string) => void;
};

export default function EvidenceEntries({ activeType, onSelectType }: EvidenceEntriesProps) {
  return (
    <div className="w-full px-4 md:px-6">
      <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="font-label text-xs uppercase tracking-[0.22em] text-primary-600">
            Browse by type
          </span>
          <h3 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            四类证据入口
          </h3>
        </div>
        <p className="max-w-md text-sm leading-6 text-foreground-600">
          先按类型缩小范围，再进卡片流对照来源与时间戳，检索更快、角度更清楚。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {evidenceTypes.map((type) => {
          const active = activeType === type.id;
          return (
            <button
              key={type.id}
              type="button"
              onClick={() => {
                onSelectType(active ? "all" : type.id);
                document.getElementById("archive")?.scrollIntoView({ behavior: "smooth" });
              }}
              className={`group cursor-pointer overflow-hidden rounded-lg border text-left transition-colors ${
                active
                  ? "border-primary-400 bg-primary-50"
                  : "border-background-200 bg-background-50 hover:border-secondary-300"
              }`}
            >
              <div className="relative h-36 w-full overflow-hidden">
                <img
                  src={type.image}
                  alt={`黑料照片 ${type.name} 实锤素材入口`}
                  title={`黑料照片 ${type.name}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-background-50/95 px-2 py-1 font-label text-[11px] text-foreground-700">
                  {type.count}
                </span>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <span
                    className={`flex h-8 w-8 items-center justify-center rounded-md ${
                      active ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                    }`}
                  >
                    <i className={`${type.icon} text-lg`} />
                  </span>
                  <h4 className="font-heading text-base font-bold text-foreground-950">
                    {type.name}
                  </h4>
                </div>
                <p className="mt-3 text-xs leading-6 text-foreground-600">{type.desc}</p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}